import React, { useState, useEffect, useRef } from 'react';
import './Management.css';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import BannerLogo from '../../components/BannerLogo';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandPointer, faArrowRight, faUser, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import LaxmanProfile from '../../assets/images/Lakshman.jpeg';
// Fallback image using data URL for Vivek Challa's profile
const VIVEK_PHOTO_FALLBACK = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAgMjAwIiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCI+PHJlY3Qgd2lkdGg9IjIwMCIgaGVpZ2h0PSIyMDAiIGZpbGw9IiMzNDk4ZGIiIC8+PGNpcmNsZSBjeD0iMTAwIiBjeT0iNzAiIHI9IjQwIiBmaWxsPSIjZWNmMGYxIiAvPjxyZWN0IHg9IjUwIiB5PSIxMTAiIHdpZHRoPSIxMDAiIGhlaWdodD0iOTAiIGZpbGw9IiNlY2YwZjEiIC8+PHRleHQgeD0iMTAwIiB5PSIxNjAiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0iIzM0OThkYiI+Vi4gQ2hhbGxhPC90ZXh0Pjwvc3ZnPg==';
 
// Try to import the image, but provide a fallback if it doesn't exist
let VivekPhoto;
try {
  VivekPhoto = require('../../assets/images/vivek.png');
} catch (e) {
  // Use the fallback if the image doesn't exist
  VivekPhoto = VIVEK_PHOTO_FALLBACK;
}

// Import Srinivasu's photo
let SriniPhoto;
try {
  SriniPhoto = require('../../assets/images/srini.png');
} catch (e) {
  // Use a fallback if the image doesn't exist
  SriniPhoto = null;
}
let LaxmanPhoto;
try {
  LaxmanPhoto = require('../../assets/images/Lakshman.jpeg');
} catch (e) {
  // Use a fallback if the image doesn't exist
  LaxmanPhoto = null;
}
// Import S. Radhakrishna's photo
let SrkPhoto;
try {
  SrkPhoto = require('../../assets/images/Srk.jpg');
} catch (e) {
  // Use a fallback if the image doesn't exist
  SrkPhoto = null;
}

// Import background images for modals
let VivekBgImage, SriniBgImage, SrkBgImage, PattabhiBgImage, LaxmanImage;

try {
  VivekBgImage = require('../../assets/images/vivekbg.jpg');
} catch (e) {
  VivekBgImage = null;
}

try {
  SriniBgImage = require('../../assets/images/srinibg.jpg');
} catch (e) {
  SriniBgImage = null;
}

try {
  SrkBgImage = require('../../assets/images/srkbg.jpg');
} catch (e) {
  SrkBgImage = null;
}

try {
  LaxmanImage = require('../../assets/images/Lakshman.jpeg');
} catch (e) {
  SrkBgImage = null;
}
try {
  PattabhiBgImage = require('../../assets/images/pattabhibg.jpg');
} catch (e) {
  PattabhiBgImage = null;
}

// Modal component for director details
const DirectorModal = ({ isOpen, onClose, director }) => {
  if (!isOpen || !director) return null;
  
  return (
    <motion.div 
      className="director-modal-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      <motion.div 
        className="director-modal"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 50 }}
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header">
            <button className="close-button" onClick={onClose}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          
          <div className="modal-body">
            <div className="director-profile">
              <div className="profile-image-container">
                {director.photo ? (
                  <img 
                    src={director.photo} 
                    alt={director.name} 
                    className="profile-image"
                    onError={(e) => {
                      if (director.id === 1) {
                        e.target.src = VIVEK_PHOTO_FALLBACK;
                      }
                    }}
                  />
                ) : (
                  <div className="profile-image" style={{ background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', aspectRatio: '1/1', width: '100%', height: '100%' }}>
                    <FontAwesomeIcon icon={faUser} style={{ fontSize: '80px', color: '#ddd' }} />
                  </div>
                )}
              </div>
              
              <div className="profile-details">
                <h2 className="profile-name">{director.name}</h2>
                <h3 className="profile-title">{director.title}</h3>
                
                <div className="profile-bio">
                  {director.details.map((detail, index) => (
                    <p key={index} className="bio-paragraph">{detail}</p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};
 
const Management = () => {
  const [activeDirector, setActiveDirector] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedDirector, setSelectedDirector] = useState(null);
  const detailsRef = useRef(null);
  const scrollPositionRef = useRef(0);
 
  // Effect to handle modal scrolling
  useEffect(() => {
    // Add class to body when on management page
    document.body.classList.add('management-page-active');

    if (modalOpen) {
      // Save current scroll position before locking
      scrollPositionRef.current = window.pageYOffset;
      
      // Lock scroll
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPositionRef.current}px`;
      document.body.style.width = '100%';
    } else {
      // Unlock scroll and restore position
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      
      // Restore scroll position
      window.scrollTo(0, scrollPositionRef.current);
    }
   
    // Clean up function
    return () => {
      document.body.classList.remove('management-page-active');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
    };
  }, [modalOpen]);
 
  // Function to handle image load errors
  const handleImageError = (directorId) => {
    // Use fallback image for Vivek Challa
    if (directorId === 1) {
      return VIVEK_PHOTO_FALLBACK;
    }
    return null;
  };
 
  // Function to handle card click
  const handleCardClick = (director, event) => {
    if (event) {
      event.preventDefault();
    }
    setSelectedDirector(director);
    setModalOpen(true);
  };

  // Function to close modal
  const closeModal = () => {
    setModalOpen(false);
  };
 
  const directors = [
    {
      id: 1,
      name: 'Vivek Challapally',
      title: 'Director',
      photo: VivekPhoto,
      details: [
        'Masters in Technology (Mechanical) in Designs from IIT, Kharagpur.',
        'Over 40 years of rich Industrial Experience in the field of Project Management, Finance & General Administration.',
        'Was COO for a MNC in the manufacturing sector.',
        'Exhaustive experience in Design, Fabrication & Erection of Industrial Piping, Steel Structures, Equipment Erection for a variety of Industries which include Steel Plants, Power Plants, Defense Establishments, Nuclear Plants, Ship Building etc.',
        'Experienced in Bid Evaluation, Negotiations, Finalization of Contracts, Execution of Projects and Commissioning.',
        'Experienced in Project Management, Construction Management, Quality Assurance Services.',
        'Experienced in Interacting with Statutory Authorities, Government Bodies etc.',
        'Involved in detailed engineering projects and DPR preparation for Sponge Iron Plants, Chemical Plants etc.',
        'Undertook 3rd party inspection of equipment for import from abroad.',
        'Fair market valuations completed for many steel manufacturing companies, oil refineries, power projects, construction projects etc.',
        'Fellow of the Institution of Engineers',
        'Fellow of the Institution of Valuers',
        'Registered Valuer u/s 34AB of the Wealth Tax Act, 1957 for Plant & Machinery'
      ]
    },
    {
      id: 2,
      name: 'Srinivasu V',
      title: 'Director',
      photo: SriniPhoto,
      details: [
        'Srinivasu V (Srini) is a seasoned professional with 28+ years of experience across manufacturing, hospitality, IT, sourcing, and Unicorns. A management accountant with a Master\'s in Commerce, he blends financial expertise with technology, excelling in logistics, accounting, reporting, outsourcing, and business transformation.',
        'Specializes in logistics, reporting, and business transformation.',
        'Extensive experience in financial strategy and operational excellence.',
        'Expert in implementing financial systems and process optimization.'
      ]
    },
    {
      id: 3,
      name: 'S. Radhakrishna',
      title: 'Consultant',
      photo: SrkPhoto,
      details: [
        'Masters in Technology (Mech.) in Machine Design from IIT, Kharagpur.',
        'Over 45 years Experience in Design and Manufacturing sector.',
        'Served in senior position in HMT (SPM & CNC Divisions), Veljan Hydrair, Denison Hydraulics, Nor crane & Winch',
        'Highly Experienced in Design of CNC Machine Tools, Special Purpose Machines, Fluid Power Equipment, Deck Machinery and other ship related equipment.',
        'Responsibilities include Design, Production, Sales, Purchase, Outsourcing, HR etc.'
      ]
    },
    {
      id: 4,
      name: 'Shivkumar Lakshman',
      title: 'Vice President',
      photo: LaxmanPhoto,
      details: [
        'Shivkumar Lakshman brings over 34 years of rich, cross-border experience with a deep focus on the renewable energy sector. As Vice President – Projects, he oversees solar EPC execution from design through commissioning, ensuring timely delivery and operational excellence. Shivkumar has successfully led the execution of over 200 MW of solar installations.',
        'His expertise lies in helping large enterprises achieve their sustainability targets by aligning technical delivery with customer goals. He previously held senior positions at Renewsys India, where he drove project leadership and client strategy across various business units.',
        'With hands-on execution knowledge and a consultative mindset, Shivkumar plays a pivotal role in driving our renewable energy vision forward. He holds an academic qualification in Masters in Business Administration.'
      ]
    },
    
  ];
 
  return (
    <div>
    <div className="management-page">
      <Navbar />
     
      <div className="management-container">
        {/* Management Hero Section */}
        <div className="management-hero">
          <img 
            src={require('../../assets/images/management.webp')} 
            alt="Management Banner" 
            className="hero-image" 
          />
          <div className="hero-overlay"></div>
          <h1 className="our-leaders-heading">Our Management Team</h1>
          <div className="hero-logo-wrapper">
            <BannerLogo />
          </div>
        </div>

        <div className="intro-section">
          <motion.div
            className="intro-content"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h2>Management Team</h2>
            <p>Our management team brings together decades of expertise across Engineering and finance sectors.</p>
          </motion.div>
        </div>
 
        <motion.div
          className="content-container"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.h3
            className="section-title"
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            Our Management Team
          </motion.h3>
         
          <div className="directors-grid">
            {directors.map((director, index) => (
              <motion.div
                key={director.id}
                className={`director-card ${activeDirector === director.id ? 'active' : ''}`}
                initial={{ opacity: 0, scale: 0.9, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{
                  duration: 0.7,
                  delay: index * 0.15,
                  ease: [0.175, 0.885, 0.32, 1.275]
                }}
                whileHover={{
                  scale: 1.03,
                  transition: { duration: 0.4 }
                }}
                onClick={(e) => handleCardClick(director, e)}
              >
                <div className="click-indicator">
                  <FontAwesomeIcon icon={faHandPointer} />
                </div>
                <div className="director-image-container">
                  {director.photo ? (
                    <img 
                      src={director.photo} 
                      alt={director.name} 
                      className="director-image"
                      onError={(e) => {
                        if (director.id === 1) {
                          e.target.src = VIVEK_PHOTO_FALLBACK;
                        }
                      }}
                    />
                  ) : (
                    <div className="director-image" style={{ background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%' }}>
                      <FontAwesomeIcon icon={faUser} style={{ fontSize: '50px', color: '#ddd' }} />
                    </div>
                  )}
                </div>
                <div className="director-info">
                  <h2 className="director-name">{director.name}</h2>
                  <h3 className="director-title">{director.title}</h3>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
    
    <div className="management-cta">
      <div className="container">
        <h3 className="cta-heading">MOVE ON TO NEXT STEP</h3>
        <h2 className="cta-title">CREDENTIALS</h2>
        <p className="cta-description">
          Get to know our project expertize.
        </p>
        <Link to="/credentials" className="cta-button">
          Credentials <FontAwesomeIcon icon={faArrowRight} />
        </Link>
      </div>
    </div>
    
    <Footer />

    {/* Director Modal */}
    <AnimatePresence>
      {modalOpen && (
        <DirectorModal 
          isOpen={modalOpen} 
          onClose={closeModal} 
          director={selectedDirector} 
        />
      )}
    </AnimatePresence>
    </div>
  );
};
 
export default Management;
 